import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import { string, bool, node } from 'prop-types';
import Button from './Button.js';
import Icon from '../Icon/Icon.js';

const dropdownButtonPropTypes = {
  accessibleLabel: string,
  active: bool,
  children: node.isRequired,
  className: string
};
const DropdownButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    accessibleLabel = 'Expand',
    active = false,
    children,
    className,
    ...otherProps
  } = props;
  const baseClass = 'nui-dropdown-button';
  const activeClass = active ? `${baseClass}--active` : false;
  return /*#__PURE__*/React__default.createElement(Button, _extends({}, otherProps, {
    className: cx(baseClass, activeClass, className),
    ref: ref
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "nui-dropdown-button_label-text"
  }, children), /*#__PURE__*/React__default.createElement(Icon, {
    name: "chevron-down",
    title: accessibleLabel
  }));
});
DropdownButton.propTypes = dropdownButtonPropTypes;
DropdownButton.displayName = 'NuiDropdownButton';
var DropdownButton$1 = DropdownButton;

export { DropdownButton$1 as default };
